import { combineReducers } from '@reduxjs/toolkit';
import undoable from 'redux-undo';
import rowsReducer from './rowsSlice';
import rowMutationsReducer from './rowMutationsSlice';
import columnsReducer from './columnsSlice';
import selectionReducer from './selectionSlice';
import focusReducer from './focusSlice';
import editingReducer from './editingSlice';
import groupByReducer from './groupBySlice';
import sortingReducer from './sortingSlice';
import filtersReducer from './filtersSlice';
import clipboardReducer from './clipboardSlice';
import collapsedGroupsReducer from './collapsedGroupsSlice';
import pluginFeaturesReducer from './pluginFeaturesSlice';
import viewsReducer from './viewsSlice';
import displayReducer from './displaySlice';
import cellChangesReducer from './cellChangesSlice';
import gridLoadingReducer from './gridLoadingSlice';
import deletedRowsReducer from './deletedRowsSlice';
import saveActionReducer from './saveActionSlice';
import saveViewsActionReducer from './saveViewsActionSlice';
import filterChangeActionReducer from './filterChangeActionSlice';
import controlledFiltersReducer from './controlledFiltersSlice';

// TV1-1690 / B-6: rowsReducer is NO LONGER wrapped in `undoable`. Row-level
// mutations are tracked explicitly via `rowMutationsSlice` (insert/delete
// deltas, limit 10) — which is dramatically cheaper than snapshotting the
// entire entity-adapter state on every update. Cell edits remain undoable
// via `cellChangesReducer` ({ limit: 50 }), where each entry is one
// per-cell {oldValue, newValue, status} record.
const undoableCellChangesReducer = undoable( cellChangesReducer, {
  limit: 50
});

const spreadsheetReducer = combineReducers({
    rows: rowsReducer,
    rowMutations: rowMutationsReducer,
    columns: columnsReducer,
    selection: selectionReducer,
    focus: focusReducer,
    editing: editingReducer,
    groupBy: groupByReducer,
    sorting: sortingReducer,
    filters: filtersReducer,
    clipboard: clipboardReducer,
    collapsedGroups: collapsedGroupsReducer,
    pluginFeatures: pluginFeaturesReducer,
    views: viewsReducer,
    display: displayReducer,
    cellChanges: undoableCellChangesReducer,
    deletedRows: deletedRowsReducer,
    gridLoading: gridLoadingReducer,
    saveAction: saveActionReducer,
    saveViewsAction: saveViewsActionReducer,
    filterChangeAction: filterChangeActionReducer,
    controlledFilters: controlledFiltersReducer
});

const rootSpreadsheetReducer = ( state: any, action: any ) => {
  if ( action.type === 'RESET_SPREADSHEET' ) {
    state = undefined;
  }
  return spreadsheetReducer( state, action );
};

export default rootSpreadsheetReducer;
